<pmv-input-search *ngIf="filter" placeholder="Pesquisar" #filterSearchInput></pmv-input-search>
<p-table #table [columns]="columns" [value]="values" [loading]="loading" loadingIcon="fa-spinner" [paginator]="paginator"
  [rows]="rows" [first]="first" [totalRecords]="totalRecords" [sortMode]="multipleSort ? 'multiple' : 'single'" [selectionMode]="selectionMode"
  [(selection)]="selected" [metaKeySelection]="metaKeySelection" [lazy]="lazy" (onLazyLoad)="onLazyLoad($event)" (onPage)="onPage($event)" [ngClass]="{'disablepage': !totalRecords || (totalRecords <= rows)}">
  <ng-template pTemplate="header">
    <tr *ngIf="showHeader">
      <th *ngIf="selectWithCheckbox" style="width: 2.25em">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let col of columns">
        <div *ngIf="col.sortable; then sortableColumn; else notSortableColumn"></div>
        <ng-template #sortableColumn>
          <th [style.width]="col.width" [attr.title]="col.tooltipTitle" [ngClass]="col.headerClass" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </ng-template>
        <ng-template #notSortableColumn>
          <th [style.width]="col.width" [attr.title]="col.tooltipTitle" [ngClass]="col.headerClass">
            {{col.header}}
          </th>
        </ng-template>
      </ng-container>
      <th *ngIf="actions && actions.length" [style.width.px]="actions.length === 1 ? 55 : (actions.length * 30)">
        Ações
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-obj let-index="rowIndex">
    <tr [pSelectableRow]="obj">
      <td *ngIf="selectWithCheckbox" style="width: 2.25em">
        <p-tableCheckbox [value]="obj"></p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns" class="datatable-cell" [class.editable]="col.editable" [style.width]="col.width" [ngClass]="col.styleClass && col.styleClass(obj)" [attr.title]="displayTitle(col, obj)">
        <div *ngIf="col.editable; then editableCell; else normalCell"></div>
        <ng-template #editableCell>
          <ng-container [ngSwitch]="col.editConfig.inputType">
            <ng-container *ngSwitchDefault>
              <pmv-input-text [(ngModel)]="obj[col.field]"
                [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)"
                [readonly]="col.editConfig.readonly && col.editConfig.readonly(obj)"
                [maxlength]="col.editConfig.textConfig && col.editConfig.textConfig.maxlength"
                (keyup)="col.editConfig.textConfig.onKeyup && col.editConfig.textConfig.onKeyup(obj)"
              ></pmv-input-text>
            </ng-container>
            <ng-container *ngSwitchCase="'text'">
              <pmv-input-text [(ngModel)]="obj[col.field]"
                [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)"
                [readonly]="col.editConfig.readonly && col.editConfig.readonly(obj)"
                [maxlength]="col.editConfig.textConfig && col.editConfig.textConfig.maxlength"
                (keyup)="col.editConfig.textConfig.onKeyup && col.editConfig.textConfig.onKeyup(obj)"
              ></pmv-input-text>
            </ng-container>
            <ng-container *ngSwitchCase="'dropdown'">
              <pmv-dropdown [(ngModel)]="obj[col.field]"
                [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)"
                [options]="col.editConfig.dropdownConfig.options(obj)"
                [optionLabelField]="col.editConfig.dropdownConfig.optionLabelField"
                [optionValueField]="col.editConfig.dropdownConfig.optionValueField"
                [defaultOption]="col.editConfig.dropdownConfig.defaultOption"
                [filter]="col.editConfig.dropdownConfig.filter"
                (onChange)="col.editConfig.dropdownConfig.onChange && col.editConfig.dropdownConfig.onChange(obj)"
              ></pmv-dropdown>
            </ng-container>
            <ng-container *ngSwitchCase="'decimal'">
              <pmv-input-decimal [(ngModel)]="obj[col.field]"
                [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)"
                [readonly]="col.editConfig.readonly && col.editConfig.readonly(obj)"
                [options]="col.editConfig.decimalConfig.options"
                (keyup)="col.editConfig.decimalConfig.onKeyup && col.editConfig.decimalConfig.onKeyup(obj)"
              ></pmv-input-decimal>
            </ng-container>
            <ng-container *ngSwitchCase="'checkbox'">
              <div style="text-align: center">
                <input type="checkbox" [(ngModel)]="obj[col.field]" (ngModelChange)="col.editConfig.checkboxConfig.ngModelChange && col.editConfig.checkboxConfig.ngModelChange($event, obj)" [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'datepicker'">
              <pmv-datepicker [(ngModel)]="obj[col.field]" [disabled]="col.editConfig.disabled && col.editConfig.disabled(obj)"
                [showTime]="col.editConfig.datepickerConfig.showTime" appendTo="body">
              </pmv-datepicker>
            </ng-container>
          </ng-container>
        </ng-template>
        <ng-template #normalCell>
          <span>
            {{ displayValue(col, obj) }}
          </span>
        </ng-template>
      </td>
      <td *ngIf="actions && actions.length" [style.width.px]="actions.length === 1 ? 55 : (actions.length * 30)">
        <ng-container *ngFor="let action of actions">
          <span class="action-icon" [class.is-hidden]="action.isHidden && action.isHidden(obj, index)" (click)="actionEvent(action, obj, index)"
            [pTooltip]="action.title" tooltipPosition="left">
            <span [class]="getIcon(action, obj)"></span>
          </span>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td style="font-size: 14px !important;" [attr.colspan]="(columns && columns.length || 0) + (actions && actions.length ? 1 : 0) + (selectWithCheckbox ? 1 : 0)">{{ emptyMessage }}</td>
    </tr>
  </ng-template>
</p-table>
<span *ngIf="paginator && values && values.length" class="database-summary" [class.compact]="compactSummary">
  <div *ngIf="compactSummary; then compact; else long"></div>
  <ng-template #compact>
    {{ indexFirstObjectPage }} a {{ indexLastObjectPage }} de {{ totalRecords }}
  </ng-template>
  <ng-template #long>
    Listando de {{ indexFirstObjectPage }} a {{ indexLastObjectPage }} - {{ totalRecords }} registros
  </ng-template>
</span>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.DatatableComponent.html